import React from 'react'
import { observer } from 'mobx-react-lite'
import { useHistory } from 'react-router-dom'
import clsx from 'clsx'

import { Box } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'

import { LoginScreen } from './LoginScreen'

import { useLogic, useStore } from '../hooks/storeHook'

import { appRoutes } from '../common/appRoutes'
import { NotificationSettingsForm } from './NotificationSettings'

export const AccountScreen = observer(
  () => {
    const logic = useLogic()
    const history = useHistory()
    const classes = useStyles()
    const {user} = useStore()

    if (!user) {
      return <LoginScreen/>
    }

    return (
      <div className="body_wrapper_zero">
        <Box paddingX={1}>
          <h1>
            Аккаунт MPsklad
          </h1>

          <Box marginBottom={3}>
            Вы авторизованы: {[user.name, user.email].filter(_ => _).join(', ')}.
          </Box>

          <Box marginBottom={5} display="flex" alignItems="center" flexWrap="wrap" className={classes.toolbarRow}>
            {
              user.isSuperAdmin &&
              <>
                <button
                  className={clsx('default-button', classes.accountButton, classes.toolbarAdminButton)}
                  onClick={() => history.push(appRoutes.AdminUsers)}
                >
                  <span>Пользователи</span>
                </button>

                <button
                  className={clsx('default-button', classes.accountButton, classes.toolbarAdminButton)}
                  onClick={() => history.push(appRoutes.AdminMsAppLifecycle)}
                >
                  <span>Статистика МС-приложения</span>
                </button>
              </>
            }

            <Box marginLeft={user.isSuperAdmin ? 'auto' : undefined}>
              <button
                className={clsx('default-button', classes.accountButton, classes.logoutButton)}
                onClick={logic.logout}
              >
                Выйти
              </button>
            </Box>
          </Box>

          <Box>
            <NotificationSettingsForm user={user}/>
          </Box>
        </Box>
      </div>
    )
  })

const useStyles =
  makeStyles(
    ({spacing, palette: {mpSkladSecondary}}) => ({
      toolbarRow: {
        rowGap: spacing(1)
      },
      accountButton: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        height: 36.5,
        margin: 0
      },
      // после accountButton: иначе margin: 0 сбрасывает marginRight
      toolbarAdminButton: {
        marginRight: spacing(2)
      },
      logoutButton: {
        paddingLeft: spacing(2),
        paddingRight: spacing(2),
        backgroundColor: mpSkladSecondary.darkBlue1,
        '&:hover': {
          backgroundColor: mpSkladSecondary.lightRed
        }
      }
    }))